module.exports = __webpack_public_path__ + "img/4-1.0a9c3841.png";